import React from "react";
import {
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";




const EditHistory: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const categoryType = searchParams.get("category");
  const goBack = () => navigate(-1);

  return (
    <MainContainer>
      <div className="main_title d_flex">
        <div className="left_s">
          <h1 className="back_arrow">
            <IconButton onClick={goBack}>
              <ArrowBackIcon />
            </IconButton>
            View Edit History - {categoryType}
          </h1>
        </div>
      </div>
      <h3>22-06-2025</h3>
      {categoryType === "Event" && (
        <div className="cards">
          <div className="gap_p view_page">
            <div className="w_25">
              <h6>Guests</h6>
              <p>04</p>
            </div>


            <div className="control_group w_25">
              <h6>Seating preferences</h6>
              <p>Yes</p>
            </div>

            <div className="w_25">
              <h6>Any special request or occassion</h6>
              <p>I want to invite my parents to the event</p>
            </div>
          </div>

          <div className="control_group w_100">
            <hr />
          </div>
          <div className="section_title mb_20">
            <h2>Partner Detail</h2>
          </div>

          <div className="gap_p view_page">
            <div className="control_group w_25">
              <h6>Name</h6>
              <p>Catherine Bell</p>
            </div>
            <div className="control_group w_25">
              <h6>Dietary Requirement</h6>
              <p>Vegan, Lactose Intolerant</p>
            </div>
            <div className="control_group w_25">
              <h6>Any special request or occassion</h6>
              <p>I want to invite my parents to the event</p>
            </div>
            <div className="control_group w_25">
              <h6>Payment Status</h6>
              <p>
                Paid - <strong className="c_success">AED 500</strong>
              </p>
            </div>
            <div className="control_group w_25">
              <h6>Date & Time
              </h6>
              <p>22-6-2025, 11:00 AM

              </p>
            </div>
          </div>

          <div className="control_group w_100">
            <hr />
          </div>
          <div className="section_title mb_20">
            <h2>
              Guest Detail <span className="count">1</span>
            </h2>
          </div>

          <div className="gap_p view_page">
            <div className="control_group w_25">
              <h6>Name</h6>
              <p>Catherine Bell</p>
            </div>
            <div className="control_group w_25">
              <h6>Email</h6>
              <p>adam@gmail.com</p>
            </div>
            <div className="control_group w_25">
              <h6>Dietary Requirement</h6>
              <p>Vegan, Lactose Intolerant</p>
            </div>
            <div className="control_group w_25">
              <h6>Payment Status</h6>
              <p>
                Paid - <strong className="c_success">AED 500</strong>
              </p>
            </div>
            <div className="control_group w_25">
              <h6>Date & Time
              </h6>
              <p>22-6-2025, 11:00 AM

              </p>
            </div>
          </div>

          <div className="control_group w_100">
            <hr />
          </div>
          <div className="section_title mb_20">
            <h2>
              Guest Detail <span className="count">2</span>
            </h2>
          </div>

          <div className="gap_p view_page">
            <div className="control_group w_25">
              <h6>Name</h6>
              <p>Catherine Bell</p>
            </div>
            <div className="control_group w_25">
              <h6>Email</h6>
              <p>adam@gmail.com</p>
            </div>
            <div className="control_group w_25">
              <h6>Dietary Requirement</h6>
              <p>Vegan, Lactose Intolerant</p>
            </div>
            <div className="control_group w_25">
              <h6>Payment Status</h6>
              <p>
                Paid - <strong className="c_success">AED 500</strong>
              </p>
            </div>
            <div className="control_group w_25">
              <h6>Date & Time
              </h6>
              <p>22-6-2025, 11:00 AM

              </p>
            </div>
          </div>
       
        </div>
      )}
      {categoryType === "Dining" && (
        <div className="cards">
          <div className="gap_p view_page">
            <div className="w_25">
              <h6>Guests</h6>
              <p>05</p>
            </div>

            <div className="w_25">
              <h6>Booking Date & Time </h6>
              <p>2nd-June-2025 | 6:00PM</p>
            </div>

            <div className="control_group w_25">
              <h6>Seating preferences</h6>
              <p>Indoor Seating</p>
            </div>

            <div className="w_25">
              <h6>Any special request or occassion</h6>
              <p>I want to invite my parents to the event</p>
            </div>
          </div>


        </div>
      )}
      <h3>20-05-2025</h3>
      {categoryType === "Event" && (
        <div className="cards">
          <div className="gap_p view_page">
            <div className="w_25">
              <h6>Guests</h6>
              <p>04</p>
            </div>


            <div className="control_group w_25">
              <h6>Seating preferences</h6>
              <p>Yes</p>
            </div>

            <div className="w_25">
              <h6>Any special request or occassion</h6>
              <p>I want to invite my parents to the event</p>
            </div>
          </div>

          <div className="control_group w_100">
            <hr />
          </div>
          <div className="section_title mb_20">
            <h2>Partner Detail</h2>
          </div>

          <div className="gap_p view_page">
            <div className="control_group w_25">
              <h6>Name</h6>
              <p>Catherine Bell</p>
            </div>
            <div className="control_group w_25">
              <h6>Dietary Requirement</h6>
              <p>Vegan, Lactose Intolerant</p>
            </div>
            <div className="control_group w_25">
              <h6>Any special request or occassion</h6>
              <p>I want to invite my parents to the event</p>
            </div>
            <div className="control_group w_25">
              <h6>Payment Status</h6>
              <p>
                Paid - <strong className="c_success">AED 500</strong>
              </p>
            </div>
            <div className="control_group w_25">
              <h6>Date & Time
              </h6>
              <p>22-6-2025, 11:00 AM

              </p>
            </div>
          </div>

          <div className="control_group w_100">
            <hr />
          </div>
          <div className="section_title mb_20">
            <h2>
              Guest Detail <span className="count">1</span>
            </h2>
          </div>

          <div className="gap_p view_page">
            <div className="control_group w_25">
              <h6>Name</h6>
              <p>Catherine Bell</p>
            </div>
            <div className="control_group w_25">
              <h6>Email</h6>
              <p>adam@gmail.com</p>
            </div>
            <div className="control_group w_25">
              <h6>Dietary Requirement</h6>
              <p>Vegan, Lactose Intolerant</p>
            </div>
            <div className="control_group w_25">
              <h6>Payment Status</h6>
              <p>
                Paid - <strong className="c_success">AED 500</strong>
              </p>
            </div>
            <div className="control_group w_25">
              <h6>Date & Time
              </h6>
              <p>22-6-2025, 11:00 AM

              </p>
            </div>
          </div>

          <div className="control_group w_100">
            <hr />
          </div>
          <div className="section_title mb_20">
            <h2>
              Guest Detail <span className="count">2</span>
            </h2>
          </div>

          <div className="gap_p view_page">
            <div className="control_group w_25">
              <h6>Name</h6>
              <p>Catherine Bell</p>
            </div>
            <div className="control_group w_25">
              <h6>Email</h6>
              <p>adam@gmail.com</p>
            </div>
            <div className="control_group w_25">
              <h6>Dietary Requirement</h6>
              <p>Vegan, Lactose Intolerant</p>
            </div>
            <div className="control_group w_25">
              <h6>Payment Status</h6>
              <p>
                Paid - <strong className="c_success">AED 500</strong>
              </p>
            </div>
            <div className="control_group w_25">
              <h6>Date & Time
              </h6>
              <p>22-6-2025, 11:00 AM

              </p>
            </div>
          </div>
        
        </div>
      )}
      {categoryType === "Dining" && (
        <div className="cards">
          <div className="gap_p view_page">
            <div className="w_25">
              <h6>Guests</h6>
              <p>05</p>
            </div>

            <div className="w_25">
              <h6>Booking Date & Time </h6>
              <p>2nd-June-2025 | 6:00PM</p>
            </div>

            <div className="control_group w_25">
              <h6>Seating preferences</h6>
              <p>Indoor Seating</p>
            </div>

            <div className="w_25">
              <h6>Any special request or occassion</h6>
              <p>I want to invite my parents to the event</p>
            </div>
          </div>


        </div>
      )}

    </MainContainer>
  );
};

export default EditHistory;
